// src/utils/storySeen.js
const LS_KEY = "barterfi_story_seen_v1"; // bump if structure changes

function readAll() {
  try {
    return JSON.parse(localStorage.getItem(LS_KEY) || "{}");
  } catch {
    return {};
  }
}

function writeAll(data) {
  localStorage.setItem(LS_KEY, JSON.stringify(data));
}

// A stable composite key: viewer -> author
function k(viewerUsername, authorUsername) {
  return `${viewerUsername}::${authorUsername}`;
}

/**
 * Get the lastSeen timestamp (number, ms) for viewer on this author, or 0 if none.
 */
export function getLastSeen(viewerUsername, authorUsername) {
  const all = readAll();
  const key = k(viewerUsername, authorUsername);
  return all[key]?.lastSeenTs ?? 0;
}

/**
 * Mark seen up to a specific timestamp (number or Date/string).
 * We only ever move forward (max), never backward.
 */
export function markSeen(viewerUsername, authorUsername, tsLike) {
  const ts = typeof tsLike === "number" ? tsLike : new Date(tsLike).getTime();
  const all = readAll();
  const key = k(viewerUsername, authorUsername);
  const prev = all[key]?.lastSeenTs ?? 0;
  if (ts > prev) {
    all[key] = { lastSeenTs: ts };
    writeAll(all);
  }
}

/**
 * Has the viewer seen all up to the author's latest story?
 */
export function hasSeenAll(viewerUsername, authorUsername, latestStoryTsLike) {
  const latest = typeof latestStoryTsLike === "number"
    ? latestStoryTsLike
    : new Date(latestStoryTsLike).getTime();
  const lastSeen = getLastSeen(viewerUsername, authorUsername);
  return lastSeen >= latest;
}
